<mat-form-field class="w-100" [appearance]="appearance()">
  @if (label()) {
  <mat-label>{{ label() }}</mat-label>
  }
  
  <input
    #inputElement
    matInput
    type="text"
    [placeholder]="placeholder()"
    [ngModel]="searchText()"
    (ngModelChange)="searchText.set($event); onSearchChange()"
    (focus)="onFocus()"
    (click)="onClick()"
    [matAutocomplete]="auto"
    [disabled]="isDisabled"
    [required]="required()"
  />

  @if (isSearching()) {
    <mat-spinner matSuffix diameter="20" class="search-spinner"></mat-spinner>
  } @else {
    <mat-icon matSuffix class="dropdown-arrow">arrow_drop_down</mat-icon>
  }

  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayFn"
    (optionSelected)="onSelectionChange($event.option.value)"
    (opened)="onPanelOpen()"
    (closed)="onPanelClose()"
    class="autocomplete-panel"
  >
    @if (isSearching()) {
      <mat-option disabled>
        Searching...
      </mat-option>
    } @else if (filteredOptions().length > 20) {
      <!-- Virtual scroll only for long lists (e.g. vendor search) — it's the whole
           reason it exists. Short lists (delivery-status pickers, etc.) render as
           plain mat-options below instead of risking CDK's fixed-size virtual
           scroll windowing bugs (it has repeatedly clipped/hidden trailing options
           like "Cancelled" for no benefit on a 6-item list). -->
      <cdk-virtual-scroll-viewport
        [itemSize]="64"
        [style.height.px]="Math.min(filteredOptions().length * 64, 320)"
        class="autocomplete-viewport"
      >
        <mat-option
          *cdkVirtualFor="let option of filteredOptions(); trackBy: trackByValue"
          [value]="option.value"
          [disabled]="option.disabled"
          class="option-with-content"
        >
          <div class="option-content">
            @if (option.imageSrc) {
              <img fhImageUrl [originalUrl]="option.imageSrc" [alt]="option.label" class="option-image" />
            }
            <span class="option-label">
              {{ option.label }}
              @if (showCounts() && option.count !== undefined) {
                <span class="count">({{ option.count }})</span>
              }
            </span>
          </div>
        </mat-option>
      </cdk-virtual-scroll-viewport>
    } @else if (filteredOptions().length > 0) {
      <div class="autocomplete-plain-list">
        @for (option of filteredOptions(); track trackByValue($index, option)) {
          <mat-option
            [value]="option.value"
            [disabled]="option.disabled"
            class="option-with-content"
          >
            <div class="option-content">
              @if (option.imageSrc) {
                <img fhImageUrl [originalUrl]="option.imageSrc" [alt]="option.label" class="option-image" />
              }
              <span class="option-label">
                {{ option.label }}
                @if (showCounts() && option.count !== undefined) {
                  <span class="count">({{ option.count }})</span>
                }
              </span>
            </div>
          </mat-option>
        }
      </div>
    } @else {
      <mat-option disabled>
        @if (searchText()) {
          No matches found. Try a different search.
        } @else {
          No options available
        }
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
